import React from "react";
import App from "./App";
import { createRoot } from "react-dom/client";
import { v4 as uuidv4 } from "uuid";
import { doc, setDoc } from "firebase/firestore";
import { db } from "./firebase";

function getUserId() {
  let userId = localStorage.getItem("userId");

  if (!userId) {
    userId = "user-" + uuidv4();
    localStorage.setItem("userId", userId);
  }

  return userId;
}

async function saveUserId(userId) {
  try {
    await setDoc(doc(db, "users", userId), {
      userId: userId,
    });
    console.log("userId", userId);
  } catch (e) {
    console.error("saveUserId Error: ", e);
  }
}

const userId = getUserId();
saveUserId(userId);

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
// root.render(
//   <React.StrictMode>
//       <App />
//   </React.StrictMode>
// );

root.render(<App />);
